<template>
    <div class="pb-4">
        <div class="px-5">
            <label class="mb-3" style="float: left;">Select Rider</label>
            <div>
                <a-select show-search style="width: 100%" 
                    size="large" 
                    :filter-option="filterOption"
                    placeholder="Select Rider"
                    @change="riderSelect">
                    <a-select-option v-for="rider in riders" :key="rider.id" :value="rider.id">
                        {{rider.name}}
                    </a-select-option>
                </a-select>
            </div>
        </div>

        <div v-if="consignments && consignments.length" class="px-5 mt-4">
            <label class="mb-3" style="float: left;">Consignment</label>
            <div>
                <a-select show-search style="width: 100%" 
                    size="large" 
                    :filter-option="filterOption"
                    placeholder="Select Consignment"
                    @change="consignmentSelect">
                    <a-select-option key="1a" value="">
                        New
                    </a-select-option>
                    <a-select-option v-for="consignment in consignments" :key="consignment.id" :value="consignment.id">
                        {{consignment.unique_id}}
                    </a-select-option>
                </a-select>
            </div>
        </div>
    </div>
    
</template>
<script>
import { USER_LIST, CONSIGNMENT_LIST } from "../../../script/api";
import { getData } from "../../../script/api-service";
export default {
    props: ['hubId'],
    data() {
        return {
            riders: [],
            consignments: [],
            selectedRider: null,
        };
    },
    watch: {
        hubId(value) {
            console.log(value);
            this.getRiderList();
        },
        selectedRider(value) {
            this.getRiderCinsignments(value)
        }
    }, 
    methods: {
        async getRiderList() {
            let url = USER_LIST + '?role=Rider&paginate=false&hub_id=' + this.hubId;
            let res = await getData(url);

            if (res) {
                let masterData = res.data?.data;
                this.riders = masterData;
            }
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        riderSelect(value) {
            this.$parent.selectRider(value);
            this.selectedRider = value;
        },
        consignmentSelect(value) {
            this.$parent.selectConsignment(value);
        },
        async getRiderCinsignments(value) {
            if (value) {
                let url = CONSIGNMENT_LIST + `?status_ids=0,1&rider_id=${value}&paginate=false`;
                let res = await getData(url);

                if (res) {
                    let masterData = res.data?.data;
                    this.consignments = masterData;
                }
            }
        }
    },
    mounted() {
        // this.getRiderList();
    },
}
</script>